











































import { Component, Vue } from "vue-property-decorator";
import IconHeading from "@/components/heading/IconHeading.vue";
import {
  ALL_GROUP_ALERTS,
  AlertData,
  AllAlertData
} from "@/graphql/query/alert/group";
import { resolveAlert } from "@/graphql/mutation/resolveAlert";

import AlertRoomAutoLockList from "@/containers/AlertRoomAutoLockList.vue";
import AlertRoomBatteryList from "@/containers/AlertRoomBatteryList.vue";
import NoData from "@/basics/boxes/NoData.vue";


// アラートの種類
enum AlertType {
  AUTOLOCK_FAIL = 0,
  BATTERY_WARNING_A = 1,
  BATTERY_WARNING_B = 2,
  BATTERY_EMPTY_A = 3,
  BATTERY_EMPTY_B = 4
}

@Component({
  components: {
    AlertRoomAutoLockList,
    AlertRoomBatteryList,
    IconHeading,
    NoData    
  },
  apollo: {
    alertFeed: {
      query: ALL_GROUP_ALERTS
    }
  }
})
export default class Home extends Vue {
  alertFeed: any | null = null;

  async deleteAlert(value: string) {
    // value: 子コンポーネントから送られてくるalertId
    try {
      await resolveAlert(this.$apollo, value);
      await this.$apollo.queries.alertFeed.refresh();
      alert("削除しました");
    } catch {
      alert("削除に失敗しました");
      //this.deleteModal = false;
    }
  }

  // アラート分割
  get alertFeedData() {
    const obj = this.alertFeed.alerts;
    let result: any = {
      autoLock: [],
      wp: [],
      ep: []
    };
    Object.keys(obj).forEach(function(v: any) {
      if (obj[v].type == AlertType.AUTOLOCK_FAIL) {
        result["autoLock"].push(obj[v]);
      } else if (obj[v].type == AlertType.BATTERY_WARNING_A) {
        result["wp"].push(obj[v]);
      } else if (obj[v].type == AlertType.BATTERY_WARNING_B) {
        result["wp"].push(obj[v]);
      } else if (obj[v].type == AlertType.BATTERY_EMPTY_A) {
        result["ep"].push(obj[v]);
      } else if (obj[v].type == AlertType.BATTERY_EMPTY_B) {
        result["ep"].push(obj[v]);
      }
    });
    return result;
  }
}
